<template>
  <div class="tc-events-panel" style="border-right:none;border-top:1px solid var(--stroke-1)">
    <div class="tc-events-scroll tc-scroll">
      <div class="tc-events-day-group">
        <div class="tc-events-day-label">
          <span>Needs your input</span>
          <span class="tc-events-day-count">{{ ITEMS.length }} items</span>
        </div>
        <ul class="tc-events-list">
          <li
            v-for="item in ITEMS"
            :key="item.id"
            class="tc-event-card conf-med"
          >
            <div class="conf-bar"></div>
            <div class="tc-event-card-meta">
              <span
                v-if="item.source === 'Freshdesk'"
                class="tc-event-source-badge tc-event-source-freshdesk"
                title="Freshdesk"
                aria-label="Freshdesk"
              >F</span>
              <span
                v-else
                class="tc-event-source-badge tc-event-source-outlook"
                title="Outlook"
                aria-label="Outlook"
              >O</span>
              <span class="tc-event-card-time">{{ item.when }} · {{ item.duration }}</span>
            </div>
            <div class="tc-event-card-title">{{ item.title }}</div>
            <div class="mt-2">
              <div class="dropdown">
                <button
                  class="btn btn-outline-secondary btn-sm dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Pick project
                </button>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li><span class="dropdown-item-text" style="font-size:var(--t-13);color:var(--fg-tertiary)">No action in preview</span></li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface NeedsInputItem {
  id: string;
  title: string;
  duration: string;
  when: string;
  source?: string;
}

const ITEMS: NeedsInputItem[] = [
  {
    id: 'ni-1',
    title: 'External call w/ Globex',
    duration: '1h',
    when: 'Tue 17',
  },
  {
    id: 'ni-2',
    title: 'Cleaning up old tickets',
    duration: '35m',
    when: 'Thu 19',
    source: 'Freshdesk',
  },
];
</script>
